const ipv4Cidr = /^((25[0-5]|2[0-4]\d|((1\d{2})|([1-9]?\d)))\.){3}(25[0-5]|2[0-4]\d|((1\d{2})|([1-9]?\d)))\/([0-9]|1[0-9]|2[0-9]|3[0-2])$/;

export default ipv4Cidr;


// WEBPACK FOOTER //
// ./src/common/reg/ipv4Cidr.js